import React from 'react';
import TcnProductImage from './TcnProductImage';
import { Dropdown } from 'primereact/dropdown';
export default function TcnProductSelector({ products, value, onChange, label = 'Producto' }) {
    const options = [{ _id: null, name: 'Sin asignar', label: 'Sin asignar' }, ...products.map(p => ({ ...p, label: `${p.name} · ${p.familyCode || p.code || 'Sin código'}` }))];
    const renderProduct = p => p && <span className="tcn-product-option">{p._id && <TcnProductImage product={p} />}<span>{p.label}</span></span>;
    return <Dropdown aria-label={label} value={value || null} options={options} optionLabel="label" optionValue="_id"
        filter filterBy="name,familyCode,code" placeholder="Sin asignar" emptyFilterMessage="No se encontraron productos"
        itemTemplate={renderProduct} valueTemplate={renderProduct}
        onChange={e => onChange(e.value)} />;
}
